import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('Sessão inválida');
        window.location.href = '/';
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${API_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Erro ao processar login');
        }

        const userData = await response.json();
        
        localStorage.setItem('user', JSON.stringify(userData));
        if (userData.token) {
          localStorage.setItem('token', userData.token);
        }
        if (userData.name) {
          localStorage.setItem('userName', userData.name);
        }
        // Master: não pré-seleciona tenant (vai para Visão Geral escolher)
        if (!userData.is_master && userData.tenant_id) {
          localStorage.setItem('selectedTenantId', userData.tenant_id);
        }
        
        toast.success(`Bem-vindo, ${userData.name}!`);
        window.location.href = userData.is_master ? '/overview' : '/dashboard';

      } catch (error) {
        console.error('Auth error:', error);
        toast.error(error.message || 'Erro no login com Google');
        window.location.href = '/';
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={48} className="text-yellow-500 animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">Processando login...</p>
        <p className="text-gray-400 text-sm mt-2">Aguarde um momento</p>
      </div>
    </div>
  );
}
